export function commonHeaders() {
  let headers = {
    Accept: 'application/json;charset=UTF-8',
    'Content-Type': 'application/json;charset=UTF-8',
  };

  let token = sessionStorage.getItem('token');
  if (token) {
    headers['Authorization'] = token;
  }

  let skipMaintenance = localStorage.getItem('skipMaintenance');
  if (skipMaintenance) {
    headers['SkipMaintenance'] = skipMaintenance;
  }

  return headers;
}

export function commonErrorHandler(response) {
  if (response && response.status === 503) {
    location.replace('/system-maintenance');
  }

  if (response && (response.status === 200 || response.status === 201 || response.status === 204)) {
    return response;
  }
  if (response.status === 401) {
    sessionStorage.removeItem('token');
    window.location.href = '/';
  }
  throw {
    message: '서버 요청 실패',
    response,
  };
}
